import React from "react";
import { FaCheckCircle, FaTruck, FaTags, FaBolt } from "react-icons/fa";

const highlights = [
  {
    id: 1,
    title: "Special Offers",
    text: "Enjoy exclusive deals, discounts, and seasonal promotions.",
    icon: <FaTags />,
  },
  {
    id: 2,
    title: "Cash on Delivery",
    text: "Pay after receiving your product with our trusted COD service.",
    icon: <FaCheckCircle />,
  },
  {
    id: 3,
    title: "Fast Delivery",
    text: "Quick and reliable delivery across the country.",
    icon: <FaTruck />,
  },
  {
    id: 4,
    title: "Flash Sale",
    text: "Limited-time deals with massive discounts.",
    icon: <FaBolt />,
  },
];

export default function WhyUs() {
  return (
    <section className="mt-10 px-4 sm:px-6">
      <div className="rounded-2xl bg-gradient-to-r from-slate-900 to-slate-700 p-5 text-white shadow-sm sm:p-6">
        <div className="mb-5 text-center sm:mb-6">
          <h3 className="text-2xl font-extrabold sm:text-3xl">
            Why Shop With Us?
          </h3>
          <p className="mt-2 text-sm text-slate-200 sm:text-base">
            From unbeatable offers to fast delivery and secure payments, we make
            shopping simple, safe, and exciting.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {highlights.map((item) => (
            <article
              key={item.id}
              className="group rounded-xl border border-white/15 bg-white/10 p-4 backdrop-blur
             animate-fade-up
             transition-all duration-300 ease-out
             hover:-translate-y-2 hover:bg-white/20 hover:shadow-xl hover:shadow-cyan-500/20"
            >
              <span
                className="inline-flex h-10 w-10 items-center justify-center rounded-full
               bg-cyan-400 text-slate-900
               transition-transform duration-300
               group-hover:scale-110 group-hover:rotate-6"
              >
                {item.icon}
              </span>

              <h4 className="mt-3 sm:text-base text-sm font-bold transition-colors duration-300 group-hover:text-cyan-300">
                {item.title}
              </h4>

              <p className="mt-1 sm:text-sm text-xs text-slate-200 transition-opacity duration-300 group-hover:opacity-90">
                {item.text}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
